export const Phone = ({ src, alt, className = "", testid }) => (
  <div data-testid={testid}
    className={`relative overflow-hidden rounded-[2rem] border-[6px] border-[#162238] bg-[#0A101D] shadow-[0_30px_80px_-20px_rgba(0,229,255,0.35)] ${className}`}>
    <img src={src} alt={alt} loading="lazy" className="block h-auto w-full" />
    <div className="pointer-events-none absolute inset-0 rounded-[1.6rem] ring-1 ring-inset ring-cyan-400/20" />
  </div>
);
